<template>
    <v-card
        block
        outlined
        elevation="0"
        :href="(item.url) ? item.url : null"
        :target="(item.url) ? '_blank' : null"
        :rel="(item.url) ? 'external' : null"
        class="event-card"
    >
        <div class="image">
            <v-img
                :src="item.thumbnail.url"
                v-if="item.thumbnail"
                contain
            ></v-img>
            <p v-else class="icon mb-0 text-center"><v-icon color="primary">fal fa-calendar-day</v-icon></p>
        </div>

        <p class="text-center ma-3">
            {{ item.title }}
            <small class="d-block text--secondary">{{ item.date|luxon('dd.MM.yyyy') }}</small>
        </p>
        <v-card-actions class="align-center grey lighten-3" v-if="item.url">
            <v-btn text small color="primary">View</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon color="primary"><v-icon>fal fa-angle-right</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "EventCard",
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
